import { Button, InputText } from "@sellar-io/components";
import { ReactElement, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useEvents } from "../../../../hooks";
import { apiV2AssertError } from "../../../../hooks/api/v2/apiV2Request";
import { useStorefrontLinkDelete } from "../../../../hooks/api/v2/storefrontLink/useStorefrontLinkDelete";
import { useSellarCurrentBusiness } from "../../../../hooks/useSellarCurrentBusiness.shared";
import { Alert } from "../../../alert/Alert";
import { InputLabel, InputContainer } from "@sellar-io/components";
import { DialogCTA } from "../../../modal/Dialog";
import { useFullPageDialogContext } from "../../../modal/useFullPageDialogContext";
import { SpinnerLegacy } from "../../..";
import {
  SharePricingDialogPage,
  SharePricingSource,
} from "./SharePricingDialogTypes";

export function SharePricingDialogDeactivatePageContent({
  storefrontLinkId,
  source,
  onDismiss,
}: {
  storefrontLinkId: number;
  source: SharePricingSource;
  onDismiss?: () => void;
}): ReactElement {
  const { track } = useEvents();
  const { business } = useSellarCurrentBusiness();
  const { setPage } = useFullPageDialogContext();
  const form = useForm({
    defaultValues: {
      deactivateString: null,
    },
  });

  const [error, setError] = useState<string>();
  const deactivateString = useWatch({
    control: form.control,
    name: "deactivateString",
  });
  const disabled = deactivateString !== "DEACTIVATE";

  const storefrontLinkDeleteMutation =
    useStorefrontLinkDelete(storefrontLinkId);
  const onDelete = () => {
    if (disabled) setError("Please enter 'DEACTIVATE' correctly");
    storefrontLinkDeleteMutation.mutate(undefined, {
      onSuccess: () => {
        track("Price Tier Link Deactivated", {
          supplierName: business?.name,
          source,
        });
        onDismiss?.();
        setPage(SharePricingDialogPage.PRICE_TIER_LINK);
      },
    });
  };
  return (
    <>
      {storefrontLinkDeleteMutation.isPending ? (
        <SpinnerLegacy />
      ) : (
        <>
          {storefrontLinkDeleteMutation.isError ||
            (error && (
              <Alert
                type={"error"}
                message={
                  apiV2AssertError(storefrontLinkDeleteMutation.error)
                    ?.message ?? error
                }
              />
            ))}
          <Alert
            type={"warning"}
            message={
              "Re-activating a link for this price tier will generate a different one"
            }
            title={
              "Your customers will no longer be able to access your pricing if you choose to deactivate this link"
            }
            className="mb-4"
          />

          <InputLabel className="mb-4">
            Type the word 'DEACTIVATE' to confirm
          </InputLabel>
          <InputContainer>
            <InputText
              {...form.register("deactivateString", { required: true })}
              placeholder={"DEACTIVATE"}
            />
          </InputContainer>
          <DialogCTA>
            <Button color={"red"} onClick={onDelete} disabled={disabled}>
              DEACTIVATE
            </Button>
          </DialogCTA>
        </>
      )}
    </>
  );
}
